import useSWR from "swr";

import {
  PLACEHOLDER_ACCOUNT,
  getBalanceAndSupplyData,
  getDepositBalanceData,
  getProcessedData,
  getStakingData,
} from "lib/legacy";

import MlpManager from "sdk/abis/MlpManager.json";
import ReaderV2 from "sdk/abis/ReaderV2.json";
import RewardReader from "sdk/abis/RewardReader.json";
import Token from "sdk/abis/Token.json";
import Vault from "sdk/abis/Vault.json";

import { useMoneyPrice } from "domain/legacy";

import { getServerUrl } from "config/backend";
import { getContract } from "config/contracts";
import useVestingData from "domain/vesting/useVestingData";
import { contractFetcher } from "lib/contracts";
import { formatKeyAmount } from "lib/numbers";
import useWallet from "lib/wallets/useWallet";

export default function APRLabel({ chainId, label }) {
  const { active } = useWallet();
  const vestingData = useVestingData();
  const rewardReaderAddress = getContract(chainId, "RewardReader");
  const readerAddress = getContract(chainId, "Reader");

  const vaultAddress = getContract(chainId, "Vault");
  const nativeTokenAddress = getContract(chainId, "NATIVE_TOKEN");
  const moneyAddress = getContract(chainId, "MONEY");
  const esMoneyAddress = getContract(chainId, "ES_MONEY");
  const bnMoneyAddress = getContract(chainId, "BN_MONEY");
  const mlpAddress = getContract(chainId, "MLP");

  const stakedMoneyTrackerAddress = getContract(chainId, "StakedMoneyTracker");
  const bonusMoneyTrackerAddress = getContract(chainId, "BonusMoneyTracker");
  const feeMoneyTrackerAddress = getContract(chainId, "FeeMoneyTracker");

  const stakedMlpTrackerAddress = getContract(chainId, "StakedMlpTracker");
  const feeMlpTrackerAddress = getContract(chainId, "FeeMlpTracker");
  const extendedMoneyTrackerAddress = getContract(chainId, "ExtendedMoneyTracker");

  const mlpManagerAddress = getContract(chainId, "MlpManager");

  const walletTokens = [moneyAddress, esMoneyAddress, mlpAddress, stakedMoneyTrackerAddress];
  const depositTokens = [
    moneyAddress,
    esMoneyAddress,
    stakedMoneyTrackerAddress,
    bonusMoneyTrackerAddress,
    bnMoneyAddress,
    mlpAddress,
  ];
  const rewardTrackersForDepositBalances = [
    stakedMoneyTrackerAddress,
    stakedMoneyTrackerAddress,
    bonusMoneyTrackerAddress,
    feeMoneyTrackerAddress,
    feeMoneyTrackerAddress,
    feeMlpTrackerAddress,
  ];
  const rewardTrackersForStakingInfo = [
    stakedMoneyTrackerAddress,
    bonusMoneyTrackerAddress,
    feeMoneyTrackerAddress,
    stakedMlpTrackerAddress,
    feeMlpTrackerAddress,
    // extendedMoneyTrackerAddress,
  ];

  const { data: walletBalances } = useSWR(
    [`StakeV2:walletBalances:${active}`, chainId, readerAddress, "getTokenBalancesWithSupplies", PLACEHOLDER_ACCOUNT],
    {
      fetcher: contractFetcher(undefined, ReaderV2, [walletTokens]),
    }
  );

  const { data: depositBalances } = useSWR(
    [`StakeV2:depositBalances:${active}`, chainId, rewardReaderAddress, "getDepositBalances", PLACEHOLDER_ACCOUNT],
    {
      fetcher: contractFetcher(undefined, RewardReader, [depositTokens, rewardTrackersForDepositBalances]),
    }
  );

  const { data: stakingInfo } = useSWR(
    [`StakeV2:stakingInfo:${active}`, chainId, rewardReaderAddress, "getStakingInfo", PLACEHOLDER_ACCOUNT],
    {
      fetcher: contractFetcher(undefined, RewardReader, [rewardTrackersForStakingInfo]),
    }
  );

  const { data: stakedMoneySupply } = useSWR(
    [`StakeV2:stakedMoneySupply:${active}`, chainId, moneyAddress, "balanceOf", stakedMoneyTrackerAddress],
    {
      fetcher: contractFetcher(undefined, Token),
    }
  );

  const { data: aums } = useSWR([`StakeV2:getAums:${active}`, chainId, mlpManagerAddress, "getAums"], {
    fetcher: contractFetcher(undefined, MlpManager),
  });

  const { data: nativeTokenPrice } = useSWR(
    [`StakeV2:nativeTokenPrice:${active}`, chainId, vaultAddress, "getMinPrice", nativeTokenAddress],
    {
      fetcher: contractFetcher(undefined, Vault),
    }
  );
  const { moneyPrice } = useMoneyPrice(chainId, {}, active);

  // const moneySupplyUrl = getServerUrl(chainId, "/money_supply");
  // const { data: moneySupply } = useSWR(moneySupplyUrl, {
  //   fetcher: (url) => fetch(url).then((res) => res.text()),
  // });

  const { data: moneySupply } = useSWR(
    [`StakeV2:moneySupply:${active}`, chainId, moneyAddress, "totalSupply"],
    {
      fetcher: contractFetcher(undefined, Token),
    }
  );

  let aum;
  if (aums && aums.length > 0) {
    aum = (aums[0] + aums[1]) / 2n;
  }

  const { balanceData, supplyData } = getBalanceAndSupplyData(walletBalances);
  const depositBalanceData = getDepositBalanceData(depositBalances);
  const stakingData = getStakingData(stakingInfo);

  const processedData = getProcessedData(
    balanceData,
    supplyData,
    depositBalanceData,
    stakingData,
    vestingData,
    aum,
    nativeTokenPrice,
    stakedMoneySupply,
    moneyPrice,
    moneySupply
  );

  return <>{`${formatKeyAmount(processedData, label, 2, 2, true)}%`}</>;
}
